import dark from "./dark";
import light from "./light";

// eslint-disable-next-line import/no-anonymous-default-export
export default { dark, light };
